import React, { Component } from "react";

import { connect } from "react-redux";

import {
  setCurrentEmailCampaignData,
  setCurrentNewsletterTemplate,
  setCurrentCampaignTheme,
} from "../../../actions/actions";

import { fetchTemplate, fetchTemplates } from "../../../actions/thunks/theme";
import ThemeItem from "../../theme/ThemeItem";

import _ from "i18n";
import { ucFirst } from "../../../services/common";
import NotFound from "../../notFound/NotFound";
import ThemeFetching from "../../fetching/ThemeFetching";
import { fetchLastSentCampaign } from "../../../actions/thunks/campaign";

const mapStateToProps = (state) => ({
  client: state.auth.currentClient,
  currentStep: state.currentCampaign.email.currentSideBar === "MODELS",
});

const mapDispatchToProps = (dispatch) => ({
  fetchTemplate: (id) => dispatch(fetchTemplate(id)),
  setCurrentCampaign: (data) => dispatch(setCurrentEmailCampaignData(data)),
  fetchTemplates: (data) => dispatch(fetchTemplates(data)),
  setCurrentNewsletterTemplate: (data) =>
    dispatch(setCurrentNewsletterTemplate(data)),
  getLastSentCampaign: (sendMode) => dispatch(fetchLastSentCampaign(sendMode)),
  setCurrentCampaignTheme: (theme) => dispatch(setCurrentCampaignTheme(theme)),
});

@connect(mapStateToProps, mapDispatchToProps)
export default class ModelsUA extends Component {
  constructor(props) {
    super(props);
    this.state = {
      registrationStatus: "FAILED",
      template: null,
      isFetching: false,
      themesFetched: [],
    };
  }

  componentDidMount() {
    this.setState({ isFetching: true });
    this.props
      .fetchTemplates({ ids: [13205, 14905] })
      .then((res) => {
        const data = res.value.data.data;
        this.setState({ isFetching: false, themesFetched: data });
      })
      .catch((error) => {
        console.error("Error fetching template:", error);
        this.setState({ isFetching: false });
      });
  }

  fetchSelectedTemplate(idTheme) {
    const {
      fetchTemplate,
      setSendMode,
      setCurrentCampaign,
      setCurrentNewsletterTemplate,
      setPeriodConfig,
      setCurrentCampaignTheme,
      getLastSentCampaign,
    } = this.props;
    this.props.handleDynamicFieldChange();
    fetchTemplate(idTheme).then((res) => {
      this.setState({ themesFetched: [] });
      const fetchedTemplate = res.value.data.data;
      this.setState({ template: fetchedTemplate });
      setSendMode(res.value.data.data?.sendMode);
      setCurrentCampaign({ sendMode: res.value.data.data?.sendMode });
      setCurrentCampaign({ themeId: res.value.data.data?.id });
      setCurrentNewsletterTemplate(fetchedTemplate);
      setCurrentCampaignTheme(fetchedTemplate);
      setPeriodConfig(null);
      setCurrentCampaign({ articleNewsletterId: null });
      setCurrentCampaign({
        currentSideBar: "PERIODS",
      });
      const sendMode = res.value.data?.data?.sendMode;
      if (sendMode) {
        getLastSentCampaign(sendMode)
          .then((res) => {
            console.log("Last Sent Campaign for sendMode", sendMode, res);
          })
          .catch((err) => {
            console.error(" Error fetching last campaign:", err);
          });
      }
    });
  }

  render() {
    const { isFetching, themesFetched } = this.state;
    const { currentStep } = this.props;
    return (
      <div id="send-tabs__tab" className={`${!currentStep ? "hide" : ""}`}>
        <div className="tab theme">
          <h4 className="tab-header">{ucFirst(_("select_nl_template"))}</h4>
          <div className="row">
            {isFetching ? (
              Array.from({ length: 4 }).map((_, index) => (
                <ThemeFetching key={`theme-fetching-${index}`} isUaNewsletter={true} />
              ))
            ) : themesFetched?.length > 0 ? (
              Array.from(
                new Map(themesFetched.map((item) => [item.id, item])).values(),
              ).map((template) => (
                <ThemeItem
                  key={`theme-${template.id}`}
                  {...template}
                  isUaNewsletter={true}
                  useThemeUa={() => {
                    this.fetchSelectedTemplate(template.id);
                  }}
                />
              ))
            ) : (
              <NotFound mainClass="small-10" />
            )}
          </div>
        </div>
      </div>
    );
  }
}
